module.exports = __webpack_public_path__ + "img/cotizar-icon.60a4153c.png";